import httpClient from '@/api/httpService.js';


export default function getFooterInfo() {
    return httpClient
        .get('api/info').then((response) => {
            let result = response;
            result.error = false;
            return result;
        }).catch((e) => {
            let result = {};
            result.error = true;
            result.data = e;
            return result;
        });
}